import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { upcomingTasksService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as upcomingTasksActions from './actions';

export function upcomingTasks(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_UPCOMING_TASKS),
    mergeMap(({ payload }) => {
      return upcomingTasksService.getUpcomingTasks(payload).pipe(
        map((res) =>
          upcomingTasksActions.getUpcomingTasksSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
